import React, { MouseEvent, useEffect, useState } from 'react';
import { getLastMonthString } from '../../../Utils/Date';
import ButtonWithStatus, {
  LoadingStatus,
} from '../../ButtonWithStatus';

const ReportForm: React.FC = () => {
  const [selectedMonthString, setSelectedMonthString] =
    useState<string>(getLastMonthString());
  const [isDownloaded, setIsDownloaded] = useState<boolean>(false);
  const [downloadStatus, setDownloadStatus] = useState<LoadingStatus>(
    LoadingStatus.IDLE
  );
  const [feedbackText, setFeedbackText] = useState<string>('');

  useEffect(() => {
    if (isDownloaded) {
      setIsDownloaded(false);
    }
  }, [isDownloaded]);

  const downloadFile = (event: MouseEvent) => {
    const year = Number(selectedMonthString.slice(0, 4));
    const month = Number(selectedMonthString.slice(5, 7));
    setDownloadStatus(LoadingStatus.LOADING);
    setFeedbackText('try to download');
    if (downloadStatus !== LoadingStatus.LOADING) {
      fetch(
        `${window.__ENV__.REACT_APP_FORMULAR_API}/api/report/${year}/${month}`,
        {
          method: 'GET',
          credentials: 'include',
        }
      )
        .then((response) => {
          if (response.status === 500) {
            setFeedbackText('Daten wurden nicht gefunden');
            setDownloadStatus(LoadingStatus.FAILED);
          } else if (response.status === 200) {
            setFeedbackText('Auswertung wurde heruntergeladen.');
            setDownloadStatus(LoadingStatus.SUCCESFUL);
            setIsDownloaded(true);
            response
              .blob()
              .then((res) => {
                const file = URL.createObjectURL(new Blob([res]));
                const link = document.createElement('a');
                link.href = file;
                link.setAttribute(
                  'download',
                  `Auswertung_Angebotsformular_${year}_${month}.xlsx`
                );
                document.body.appendChild(link);
                link.click();
                if (link.parentNode)
                  link.parentNode.removeChild(link);
              })
              .catch((reason) => {
                console.error(reason);
                setFeedbackText('Fehler beim Donwloaden');
                setDownloadStatus(LoadingStatus.FAILED);
              });
          } else if (response.status === 204) {
            setFeedbackText('Daten wurden nicht gefunden');
            setDownloadStatus(LoadingStatus.FAILED);
          }
        })
        .catch((reason) => {
          console.error(reason);
          setFeedbackText('Verbindung zum Backend nicht vorhanden');
          setDownloadStatus(LoadingStatus.FAILED);
        });
    }
  };

  const changeMonth = (event: any) => {
    setSelectedMonthString(event.target.value);
  };

  return (
    <form>
      <div id="form-container" className="container border py-3">
        <div className="form-group">
          <label htmlFor="month-select">Wähle den Monat aus</label>
          <input
            type="month"
            defaultValue={getLastMonthString()}
            onChange={changeMonth}
            className="form-control"
          ></input>
        </div>

        <ButtonWithStatus
          feedbackText={feedbackText}
          status={downloadStatus}
          onclick={downloadFile}
        >
          Auswertung herunterladen
        </ButtonWithStatus>
      </div>
    </form>
  );
};

export default ReportForm;
